import { combineReducers } from "@reduxjs/toolkit";
import dialogsReducer from "./slices/dialogsSlice";
import receiptChangesReducer from "./slices/receiptChangesSlice";
import receiptUploadReducer from "./slices/receiptUploadSlice";
import statusesReducer from "./slices/statusesSlice";
import tsReducer from "./slices/tsSlice";
import userReducer from "./slices/userSlice";
import yachtReducer from "./slices/yachtSlice";

const rootReducer = combineReducers({
  dialog: dialogsReducer,
  receiptChanges: receiptChangesReducer,
  receiptUpload: receiptUploadReducer,
  selectedUser: userReducer,
  selectedYacht: yachtReducer,
  statuses: statusesReducer,
  ts: tsReducer,
});

export default rootReducer;